// extracted by mini-css-extract-plugin
export default {"blueRibbon":"#0560ff","electricViolet":"#9913ff","robinsEggBlue":"#00d3dc","ticklePink":"#ff8097","cgCollectionTab":"collection-tab-module-cgCollectionTab--YL6H0"};